'use strict';

var React = require('react');

var SvgMobileHorizontalDotsMajor = function SvgMobileHorizontalDotsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }));
};
SvgMobileHorizontalDotsMajor.displayName = "MobileHorizontalDotsMajor";

exports.SvgMobileHorizontalDotsMajor = SvgMobileHorizontalDotsMajor;
